import type { ProgressReport } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ProgressReportStore } from './interfaces'

import { useDisciplineStore } from '@stores/discipline'

export const actions = {
  setReportLoading (this: ProgressReportStore, payload: ProgressReportStore['reportLoading']): void {
    this.reportLoading = payload
  },
  setReportsLoading (this: ProgressReportStore, payload: ProgressReportStore['reportsLoading']): void {
    this.reportsLoading = payload
  },
  setReports (this: ProgressReportStore, payload: ProgressReportStore['reportsEla' | 'reportsMath']): void {
    const disciplineStore = useDisciplineStore()

    if (disciplineStore.isEla) {
      this.reportsEla = payload
    } else if (disciplineStore.isMath) {
      this.reportsMath = payload
    }
  },
  setNewProgressReport (this: ProgressReportStore, payload: boolean): void {
    const disciplineStore = useDisciplineStore()

    if (disciplineStore.isEla) {
      this.newProgressReportEla = payload
    } else if (disciplineStore.isMath) {
      this.newProgressReportMath = payload
    }
  },
  setReport (this: ProgressReportStore, payload: ProgressReport | null): void {
    const disciplineStore = useDisciplineStore()

    if (disciplineStore.isEla) {
      this.reportEla = payload
    } else if (disciplineStore.isMath) {
      this.reportMath = payload
    }
  },
}
